<template>
    <v-row class="CerteuropeSignHeader" align="center">
      <v-col v-if="signingView">
        <h3 class="text-white mb-1">{{ $t('certeurope-sign.CerteuropeSignHeader.reviewAndSignDocument') }}</h3>
        <span class="text-white" v-t="{ path: 'certeurope-sign.CerteuropeSignHeader.remainingTags', plural: tagsCount }" />
        <v-chip color="white"
                size="small"
        >
          {{ tagsCount }}
        </v-chip>
      </v-col>
      <v-col class="text-right">
        <template v-if="signingView">
          <AppButton v-if="tagsCount > 0"
                    color="white"
                    class="mr-2"
                    @click="goToNextTag"
          >
            {{ $t('common.continue') }}
          </AppButton>
          <AppButton v-if="tagsCount === 0"
                    color="white"
                     :disabled="signTagPending"
                    :loading="confirmSignaturePending"
                    class="CerteuropeSignHeader-finishButton mr-2"
                    @click="onFinishClick"
          >
            {{ $t('common.finish') }}
          </AppButton>
        </template>
        <AppButton color="white"
                   :to="{
                     name: SIGN_LANDING_PAGE_ROUTE_NAME,
                     params: { mnemo },
                     query: {
                       event: 'cancel',
                     },
                    }"
        >
        {{ $t('common.close') }}
      </AppButton>
      </v-col>
    </v-row>
</template>

<script>
import { nextTick } from 'vue'
import { mapMutations, mapState } from 'vuex'

import AppButton from '@/common/buttons/AppButton.vue'
import { tagsTypes } from '@/common/prepare-signature/tagsTypes'
import { SIGN_LANDING_PAGE_ROUTE_NAME } from '@/router/routerData'
import { CerteuropeSignMutationTypes } from '@/store/modules/certeurope-sign/mutation_types'

export default {
  name: 'CerteuropeSignHeader',
  components: { AppButton },
  props: {
    mnemo: {
      type: String,
      required: true,
    },
    selectedTag: {
      required: true,
    },
  },
  data () {
    return {
      SIGN_LANDING_PAGE_ROUTE_NAME,
    }
  },
  computed: {
    ...mapState('certeuropeSign', ['signingView', 'confirmSignaturePending', 'signTagPendingIds', 'unsignTagPendingIds']),
    tagsCount () {
      if (this.signingView && this.signingView.pages.length > 0) {
        let counter = 0
        this.signingView.pages.forEach(page => {
          counter += page.tags.filter(item => !item.isSigned &&
          item.type !== tagsTypes.DATE &&
          item.type !== tagsTypes.OPTIONAL_CHECKBOX &&
          item.type !== tagsTypes.TEXT_READ_ONLY).length
        })
        return counter
      }
      return null
    },
    flattenTags () {
      const array = []
      for (const page of this.signingView.pages) {
        array.push(...page.tags)
      }
      return array
    },
    tagsToSign () {
      return this.flattenTags.filter(tag => tag.isSigned === false)
    },
    signTagPending () {
      return this.signTagPendingIds.length > 0 || this.unsignTagPendingIds.length > 0
    },
  },
  mounted () {
    this.$emit('headerHeight', `${document.querySelector('.CerteuropeSignHeader').scrollHeight}px`)
  },
  methods: {
    ...mapMutations('certeuropeSign', [CerteuropeSignMutationTypes.SET_VALIDATION_MODAL_IS_OPEN]),
    onFinishClick () {
      if (this.signingView.signatureType === 'advanced') {
        this.$store.commit(`certeuropeSign/${CerteuropeSignMutationTypes.SET_VALIDATION_MODAL_IS_OPEN}`, true)
      } else if (this.signingView.signatureType === 'simple') {
        this.$emit('confirmSimpleSignature')
      }
    },
    async goToNextTag () {
      if (this.tagsToSign.length === 0) return
      if (!this.selectedTag) {
        this.$emit('update:selectedTag', this.tagsToSign[0])
      } else {
        const nextTag = this.tagsToSign.findIndex(t => t.id === this.selectedTag.id) + 1
        if (nextTag >= this.tagsToSign.length) {
          this.$emit('update:selectedTag', this.tagsToSign[0])
        } else {
          this.$emit('update:selectedTag', this.tagsToSign[nextTag])
        }
      }

      await nextTick()

      const tag = document.querySelector(`#tag-${this.selectedTag.id}`)
      if (tag) {
        tag.scrollIntoView({
          behavior: 'smooth',
        })
      }
    },
  },
}
</script>

<style scoped lang="scss">
.CerteuropeSignHeader {
  background-color: rgb(var(--v-theme-primary));
  width: 100%;
}
.CerteuropeSignHeader-finishButton {
  animation: blink 1s infinite;
  color: rgb(var(--v-theme-primary));
}
@keyframes blink {
  0% {
    color: rgb(var(--v-theme-primary));
  }
  50% {
    color: rgb(var(--v-theme-accent));
  }
  100% {
    color: rgb(var(--v-theme-primary));
  }
}
</style>
